<script lang="ts" setup>
import Banner from './components/Banner.vue'
import Explore from './components/Explore.vue'
import Observe from './components/Observe.vue'
import Service from './components/Service.vue'
import Milestone from './components/Milestone.vue'
import Brands from './components/Brands.vue'
import Chairman from './components/Chairman.vue'
import CardBox from './components/CardBox.vue'
import Contact from './components/Contact.vue'
import { useGlobalStore } from '@/stores'
import { useWindowScroll } from '@vueuse/core'
import useSeo from './seo'
import { ArticleApi } from '@/utils/api'
import _ from 'lodash'

const { y } = useWindowScroll();
const globalStore = useGlobalStore();
const api = new ArticleApi()
const brands = await api.getArticleBrands()
let categorizedProducts = ref({} as any)
await brands.data.forEach((item: any) => {
  item.categories.forEach((category: any) => {
    if (!categorizedProducts.value[category.subject]) {
      categorizedProducts.value[category.subject] = {
        category: category,
        data: [item]
      };
    } else {
      categorizedProducts.value[category.subject].data.push(item);
    }
  });
});
watch(
  () => y.value,
  v => {
    globalStore.isWhite = v < 88;
    globalStore.isWhite1 = v >= 88;
    globalStore.isHeaderTransparent = v <= 88;
  }
)
const bannerRef = ref(null)
const cardBoxRef = ref(null)
const chairmanRef = ref(null)
const milestoneRef = ref(null)

onMounted(() => {
  useImagesLoaded('.brand-story img').then(() => {
    bannerRef.value.initAni();
    milestoneRef.value.initAni();
    chairmanRef.value.initAni();
    cardBoxRef.value.initAni();
  })
})
useSeo()
</script>

<template>
  <div class="brand-story">
    <div class="box">
      <Banner ref="bannerRef" />
      <Explore />
      <Observe />
      <Service />
      <Milestone ref="milestoneRef" />
      <Brands :categorizedProducts="categorizedProducts" />
    </div>
    <div class="chairmanBox">
      <Chairman ref="chairmanRef" />
    </div>
    <div class="box">
      <CardBox ref="cardBoxRef" />
      <Contact />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.box {
  position: relative;
  z-index: 2;
  background-color: $color-white-1;
}

.chairmanBox {
  // margin-left: toRem(-24) !important;
  // margin-right: toRem(-24) !important;
  // overflow: hidden;
  // :deep(.pin-spacer) {
  //   background-image: url('../../public/images/chairmanImg1.jpg');
  //   background-repeat: no-repeat;
  //   background-size: cover;
  // }
}
</style>
